const CS = (document.documentElement.lang || '').indexOf('cs') === 0;
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Mobile menu (fullscreen overlay)
const menuToggle = document.getElementById('menuToggle');
const mobileMenu = document.getElementById('mobileMenu');

if (menuToggle && mobileMenu) {
  // Escape the header's backdrop-filter containing block so the
  // fixed fullscreen overlay spans the real viewport.
  document.body.appendChild(mobileMenu);

  menuToggle.addEventListener('click', () => {
    const open = mobileMenu.classList.toggle('open');
    menuToggle.classList.toggle('open', open);
    document.body.classList.toggle('menu-open', open);
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // Side panel: tapping the dimmed page behind it closes the menu.
  mobileMenu.addEventListener('click', (e) => { if (e.target === mobileMenu) menuToggle.click(); });

  mobileMenu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      menuToggle.classList.remove('open');
      document.body.classList.remove('menu-open');
      menuToggle.setAttribute('aria-expanded', 'false');
    });
  });
}

// Cart + toast
let cartCount = 0;
const cartCountEl = document.querySelector('.cart-count');
const toastEl = document.getElementById('toast');
let toastTimer;

function showToast(message) {
  if (!toastEl) return;
  toastEl.textContent = message;
  toastEl.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toastEl.classList.remove('show'), 2200);
}

function bindAddToCart(btn) {
  btn.addEventListener('click', () => {
    cartCount += 1;
    if (cartCountEl) cartCountEl.textContent = cartCount;
    const original = btn.textContent;
    btn.textContent = 'PRIDANÉ ✓';
    showToast(CS ? 'Přidáno do košíku' : 'Pridané do košíka');
    setTimeout(() => { btn.textContent = original; }, 1200);
  });
}
document.querySelectorAll('[data-add-to-cart]').forEach(bindAddToCart);

// "Daj mi vedieť" — coming-soon products lead to newsletter signup
// (native #newsletter anchor handles the scroll; JS adds focus + toast)
document.querySelectorAll('[data-notify]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const target = document.getElementById('newsletter');
    if (!target) return;
    const input = target.querySelector('input[type="email"]');
    if (input) setTimeout(() => input.focus({ preventScroll: true }), prefersReducedMotion ? 0 : 600);
    showToast('Nechaj mi email a dám ti vedieť, keď to bude vonku.');
  });
});


// FAQ accordion
document.querySelectorAll('.faq-item').forEach((item) => {
  const q = item.querySelector('.faq-q');
  const a = item.querySelector('.faq-a');
  if (!q || !a) return;
  q.addEventListener('click', () => {
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach((other) => {
      other.classList.remove('open');
      other.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
      other.querySelector('.faq-a').style.maxHeight = null;
    });
    if (!isOpen) {
      item.classList.add('open');
      q.setAttribute('aria-expanded', 'true');
      a.style.maxHeight = a.scrollHeight + 'px';
    }
  });
});

// Count-up for stat chips
function animateCount(el, target, suffix) {
  const duration = 900;
  const start = performance.now();
  function frame(now) {
    const t = Math.min((now - start) / duration, 1);
    const eased = 1 - Math.pow(1 - t, 3);
    el.textContent = Math.round(target * eased).toLocaleString('sk-SK') + suffix;
    if (t < 1) requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
}

function startCounters(scope) {
  scope.querySelectorAll('.stat-chip strong').forEach((el) => {
    if (el.dataset.counted) return;
    const match = el.textContent.trim().match(/^([\d\s]+)(.*)$/);
    if (!match) return;
    const target = parseInt(match[1].replace(/\s/g, ''), 10);
    if (!Number.isFinite(target)) return;
    el.dataset.counted = '1';
    if (prefersReducedMotion) return;
    animateCount(el, target, match[2] ? match[2] : '');
  });
}

// Scroll reveal (+ counters when stats scroll in, staggered inside grids)
const revealEls = document.querySelectorAll('.reveal');
const STAGGER_GRIDS = '.product-grid, .pp-how-grid, .why-grid, .faq-list';

function revealNow(el) {
  const parent = el.parentElement;
  let delay = 0;
  if (parent && parent.matches && parent.matches(STAGGER_GRIDS)) {
    delay = Array.prototype.indexOf.call(parent.children, el) * 90;
  }
  setTimeout(() => {
    el.classList.add('visible');
    startCounters(el);
  }, prefersReducedMotion ? 0 : delay);
}

if ('IntersectionObserver' in window) {
  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        revealNow(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  revealEls.forEach((el) => io.observe(el));
} else {
  revealEls.forEach((el) => el.classList.add('visible'));
}

// Safety net: never leave content hidden even if the observer misbehaves
setTimeout(() => {
  revealEls.forEach((el) => el.classList.add('visible'));
  startCounters(document);
}, 3000);

// Product-page stats sit outside .reveal — count them shortly after load
setTimeout(() => startCounters(document), 600);

// Shrinking header + scroll progress + watermark parallax
const siteHeader = document.getElementById('siteHeader');
const watermark = document.querySelector('.hero-watermark');

const progressWrap = document.createElement('div');
progressWrap.className = 'scroll-progress';
progressWrap.setAttribute('aria-hidden', 'true');
const progressFill = document.createElement('span');
progressWrap.appendChild(progressFill);
document.body.appendChild(progressWrap);

let ticking = false;
function onScroll() {
  if (ticking) return;
  ticking = true;
  requestAnimationFrame(() => {
    const y = window.scrollY;
    if (siteHeader) siteHeader.classList.toggle('scrolled', y > 40);
    const max = document.documentElement.scrollHeight - window.innerHeight;
    progressFill.style.transform = 'scaleX(' + (max > 0 ? Math.min(y / max, 1) : 0) + ')';
    if (watermark && !prefersReducedMotion) {
      watermark.style.transform = 'translate(-50%, calc(-50% + ' + y * 0.22 + 'px))';
    }
    ticking = false;
  });
}
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();

// Card tilt (desktop, fine pointers only)
if (window.matchMedia('(pointer: fine)').matches && !prefersReducedMotion) {
  document.querySelectorAll('.product-card, .featured-frame').forEach((card) => {
    card.classList.add('tilt');
    card.addEventListener('mousemove', (e) => {
      const r = card.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width - 0.5;
      const py = (e.clientY - r.top) / r.height - 0.5;
      card.style.setProperty('--ry', (px * 7).toFixed(2) + 'deg');
      card.style.setProperty('--rx', (-py * 7).toFixed(2) + 'deg');
      card.style.setProperty('--lift', '-4px');
    });
    card.addEventListener('mouseleave', () => {
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
      card.style.setProperty('--lift', '0px');
    });
  });
}

// Sticky mobile buy bar on product pages
const heroCard = document.querySelector('.pp-hero .featured-card');
if (heroCard) {
  const primaryCta = heroCard.querySelector('.btn-primary');
  const priceEl = heroCard.querySelector('.featured-price');
  if (primaryCta && priceEl) {
    const bar = document.createElement('div');
    bar.className = 'buybar';
    const price = document.createElement('span');
    price.className = 'buybar-price';
    price.textContent = priceEl.textContent.trim();
    const cta = primaryCta.cloneNode(true);
    cta.classList.remove('featured-cta');
    if (cta.hasAttribute('data-add-to-cart')) bindAddToCart(cta);
    bar.appendChild(price);
    bar.appendChild(cta);
    document.body.appendChild(bar);

    if ('IntersectionObserver' in window) {
      const barIo = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          bar.classList.toggle('visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      barIo.observe(heroCard);
    } else {
      bar.classList.add('visible');
    }
  }
}

// Card click: the product sinks into the centre of the image and vanishes
// while the product page opens. (Cards and product hero look
// alike, so a hard cut would read as "nothing happened".)
(function () {
  if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules') && document.querySelector('.product-card, .pk-more-card')) {
    var sr = document.createElement('script');
    sr.type = 'speculationrules';
    sr.textContent = JSON.stringify({ prefetch: [{ source: 'document', where: { href_matches: '/products/*' }, eagerness: 'moderate' }] });
    document.head.appendChild(sr);
  }
  var canPrerender = !!(HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'));
  var warmed = {};
  function warm(href) {
    if (warmed[href]) return; warmed[href] = 1;
    if (canPrerender) {
      var r = document.createElement('script'); r.type = 'speculationrules';
      r.textContent = JSON.stringify({ prefetch: [{ urls: [href], eagerness: 'immediate' }] });
      document.head.appendChild(r);
    } else if (window.fetch) {
      // No DOM changes here: on iOS a DOM mutation during touch makes Safari treat the first tap
      // as "hover" and swallow the click (double-tap bug).
      try { fetch(href, { credentials: 'same-origin' }).catch(function () {}); } catch (e) {}
    }
  }
  // Start loading as soon as the finger/mouse goes down, before the click fires.
  document.addEventListener('pointerdown', function (e) {
    var a = e.target.closest && e.target.closest('.product-card a[href], .pk-more-card a[href]');
    if (a && a.origin === location.origin && a.getAttribute('href').charAt(0) !== '#') warm(a.href);
  }, { passive: true });
  if (prefersReducedMotion) return;
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.is-opening').forEach(function (c) { c.classList.remove('is-opening'); });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.product-card a[href], .pk-more-card a[href]');
    if (!a) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target === '_blank' || a.hasAttribute('download')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    var url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    a.closest('.product-card, .pk-more-card').classList.add('is-opening');
    // Never block the click: the HTML is already being fetched since pointerdown and the
    // navigation starts right now; the old page keeps animating until the new one paints.
    warm(a.href);
  });
})();

// Cut-out product shots (no background) for cart drawer / add-ons, keyed by product handle.
var RZ_CUTOUT = {
  'pyko': ['preworkout_transparent.png', '139,92,246'],
  'roiderz-mikronizovany-kreatin-monohydrat-watermelon': ['kreatin-transparent.png', '212,255,0'],
  'vypi-elektrolyty-juicy-mango': ['vypi-transparent.png', '255,122,0'],
  'tricko-forma-jak-z-p-rna': ['tricko-transparent.png', '255,43,61'],
  'ebook-chudnutie-bez-pocitania-kalorii': ['ebook-transparent.png', '255,212,0']
};
function rzCutout(img, handle, variantTitle) {
  var c = RZ_CUTOUT[handle], sc = document.querySelector('script[src*="roiderz.js"]');
  if (!c || !sc) return false;
  var file = c[0];
  if (handle === 'tricko-forma-jak-z-p-rna' && /tielko/i.test(variantTitle || '')) file = 'tielko-transparent.png';
  img.src = sc.src.replace(/roiderz\.js.*$/, file + '?width=240');
  img.classList.add('rz-cutout');
  img.style.setProperty('--rz-glow', c[1]);
  return true;
}

// Add-to-cart drawer: AJAX add, then slide-in panel with free-shipping progress
(function () {
  if (!window.fetch || !window.FormData) return;
  var FREE = 10000; // cents – doprava zadarmo nad 100 € (SK aj CZ)
  var drawer, panel;
  function money(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function el(sel) { return drawer.querySelector(sel); }
  function build() {
    drawer = document.createElement('div');
    drawer.className = 'rz-drawer';
    drawer.id = 'rzDrawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<div class="rz-drawer-bg" data-close></div>' +
      '<aside class="rz-drawer-panel" role="dialog" aria-modal="true" aria-label="' + (CS ? 'Přidáno do košíku' : 'Pridané do košíka') + '">' +
        '<div class="rz-drawer-head"><span class="rz-drawer-title">' + (CS ? 'Přidáno do košíku' : 'Pridané do košíka') + ' <span class="rz-drawer-check">✓</span></span><button type="button" class="rz-drawer-x" aria-label="Zavrieť" data-close>×</button></div>' +
        '<div class="rz-drawer-item"><img class="rz-drawer-img" alt=""><div class="rz-drawer-meta"><div class="rz-drawer-name"></div><div class="rz-drawer-var"></div></div><div class="rz-drawer-price"></div></div>' +
        '<div class="rz-ship-bar"><p class="rz-ship-bar-text"></p><div class="rz-ship-bar-track"><div class="rz-ship-bar-fill" style="width:0%"></div></div></div>' +
        '<div class="rz-addon" hidden></div>' +
        '<div class="rz-drawer-sum"><span class="rz-drawer-sum-label"></span><strong class="rz-drawer-sum-val"></strong></div>' +
        '<a href="' + (CS ? '/cs/cart' : '/cart') + '" class="btn btn-primary rz-drawer-cta">' + (CS ? 'DO KOŠÍKU' : 'DO KOŠÍKA') + '</a>' +
        '<button type="button" class="btn btn-ghost rz-drawer-continue" data-close>' + (CS ? 'POKRAČOVAT V NÁKUPU' : 'POKRAČOVAŤ V NÁKUPE') + '</button>' +
      '</aside>';
    document.body.appendChild(drawer);
    panel = el('.rz-drawer-panel');
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
  }
  var ADDONS = ['roiderz-mikronizovany-kreatin-monohydrat-watermelon', 'vypi-elektrolyty-juicy-mango', 'pyko'];
  var addonCache = {};
  function loadAddon(h) {
    if (addonCache[h]) return Promise.resolve(addonCache[h]);
    return fetch((CS ? '/cs' : '') + '/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) addonCache[h] = p; return p; })
      .catch(function () { return null; });
  }
  function renderAddons(box, cart, onAdded) {
    if (!box) return;
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.handle] = 1; });
    var want = ADDONS.filter(function (h) { return !inCart[h]; }).slice(0, 2);
    if (!want.length) { box.hidden = true; box.innerHTML = ''; return; }
    Promise.all(want.map(loadAddon)).then(function (ps) {
      ps = ps.filter(function (p) { return p && p.available && p.variants && p.variants[0]; });
      box.innerHTML = '';
      if (!ps.length) { box.hidden = true; return; }
      var gap = FREE - cart.total_price;
      var head = document.createElement('div');
      head.className = 'rz-addon-head';
      head.textContent = CS ? 'Přibal si k tomu' : 'Pribaľ si k tomu';
      box.appendChild(head);
      ps.forEach(function (p) {
        var row = document.createElement('div'); row.className = 'rz-addon-row';
        var img = document.createElement('img'); img.className = 'rz-addon-img'; img.alt = ''; img.loading = 'lazy';
        if (!rzCutout(img, p.handle, '') && p.featured_image) img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        var meta = document.createElement('div'); meta.className = 'rz-addon-meta';
        var name = document.createElement('a'); name.className = 'rz-addon-name'; name.href = (CS ? '/cs' : '') + '/products/' + p.handle; name.textContent = p.title;
        var price = document.createElement('div'); price.className = 'rz-addon-price'; price.textContent = money(p.price);
        meta.appendChild(name); meta.appendChild(price);
        if (gap > 0 && p.price >= gap) {
          var tag = document.createElement('div'); tag.className = 'rz-addon-free';
          tag.textContent = CS ? '+ doprava zdarma' : '+ doprava zadarmo';
          meta.appendChild(tag);
        }
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'rz-addon-btn';
        btn.textContent = CS ? '+ PŘIDAT' : '+ PRIDAŤ';
        btn.addEventListener('click', function () {
          btn.disabled = true; btn.textContent = '…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] }) })
            .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
            .then(function (res) { onAdded(res && res.items ? res.items[0] : res); })
            .catch(function () { btn.disabled = false; btn.textContent = CS ? '+ PŘIDAT' : '+ PRIDAŤ'; });
        });
        row.appendChild(img); row.appendChild(meta); row.appendChild(btn);
        box.appendChild(row);
      });
      box.hidden = false;
    });
  }
  function refreshDrawer(item) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { render(item, cart); });
  }
  function open() {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var x = el('.rz-drawer-x'); if (x) x.focus({ preventScroll: true });
  }
  function close() {
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }
  function render(item, cart) {
    if (!drawer) build();
    var img = el('.rz-drawer-img');
    img.classList.remove('rz-cutout');
    if (rzCutout(img, item.handle, item.variant_title)) { img.hidden = false; }
    else if (item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_240x240$1$2'); img.hidden = false; } else { img.hidden = true; }
    el('.rz-drawer-name').textContent = item.product_title || '';
    var v = el('.rz-drawer-var');
    v.textContent = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    v.hidden = !v.textContent;
    el('.rz-drawer-price').textContent = money(item.final_line_price != null ? item.final_line_price : item.price * item.quantity);
    var gap = FREE - cart.total_price;
    var pct = Math.min(100, Math.round(cart.total_price * 100 / FREE));
    var bar = el('.rz-ship-bar');
    bar.classList.toggle('is-free', gap <= 0);
    bar.hidden = false; // doprava zadarmo nad 100 € platí pre SK aj CZ
    el('.rz-ship-bar-text').innerHTML = gap > 0
      ? (CS ? 'Nakup ještě za <strong>' + money(gap) + '</strong> a dopravu máš od nás zdarma 🚀' : 'Nakúp ešte za <strong>' + money(gap) + '</strong> a dopravu máš od nás zadarmo 🚀')
      : (CS ? '<strong>Super, dopravu máš zdarma!</strong> Stačí už jen dokončit objednávku.' : '<strong>Super, dopravu máš zadarmo!</strong> Stačí už len dokončiť objednávku.');
    var fill = el('.rz-ship-bar-fill');
    fill.style.width = '0%';
    requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
    el('.rz-drawer-sum-label').textContent = (CS ? 'Celkem v košíku (' : 'Spolu v košíku (') + cart.item_count + ' ks)';
    el('.rz-drawer-sum-val').textContent = money(cart.total_price);
    var cc = document.querySelector('.cart-count'); if (cc) cc.textContent = cart.item_count;
    renderAddons(el('.rz-addon'), cart, function (added) { refreshDrawer(added || item); });
  }
  var cartAddon = document.querySelector('[data-rz-addon]');
  if (cartAddon) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      renderAddons(cartAddon, cart, function () { location.reload(); });
    }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = CS ? 'PŘIDÁVÁM…' : 'PRIDÁVAM…'; }
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (item) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { render(item, cart); open(); });
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });
})();
